import React, { useState } from 'react';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div style={{
        paddingTop: 'calc(env(safe-area-inset-top, 16px) + 80px)',
      }}>
        <div style={{
          padding: '2.5rem',
          textAlign: 'center',
          maxWidth: 420,
          margin: '3rem auto',
          background: 'linear-gradient(120deg, #f8fafc 60%, #ffe0f7 100%)',
          borderRadius: '18px',
          boxShadow: '0 6px 32px rgba(229, 46, 113, 0.10)',
          position: 'relative',
        }}>
          <div style={{ fontSize: 48, color: '#4caf50', marginBottom: 12, animation: 'pop 0.5s' }}>✔️</div>
          <h2 style={{ marginBottom: 8 }}>¡Gracias!</h2>
          <p style={{ color: '#666' }}>Tu mensaje ha sido enviado.</p>
        </div>
      </div>
    );
  }

  // Floating label style helpers
  const getLabelStyle = (value) => ({
    position: 'absolute',
    left: 18,
    top: value ? 6 : '50%',
    fontSize: value ? 13 : 16,
    color: value ? '#e52e71' : '#aaa',
    background: '#fff',
    padding: '0 4px',
    transform: value ? 'translateY(-50%)' : 'translateY(-50%)',
    transition: 'all 0.2s',
    pointerEvents: 'none',
  });

  return (
    <div style={{
      paddingTop: 'calc(env(safe-area-inset-top, 16px) + 80px)',
      paddingLeft: '16px',
      paddingRight: '16px'
    }}>
      <form onSubmit={handleSubmit} style={{
        maxWidth: 420,
        margin: '3rem auto',
        background: 'linear-gradient(120deg, #f8fafc 60%, #ffe0f7 100%)',
        borderRadius: '18px',
        boxShadow: '0 6px 32px rgba(229, 46, 113, 0.10)',
        padding: '2.5rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        position: 'relative',
      }}>
      <h2 style={{ textAlign: 'center', marginBottom: '0.5rem', color: '#e52e71', letterSpacing: 1 }}>Contáctanos</h2>
      {/* Name Field */}
      <div style={{ position: 'relative', marginBottom: 8 }}>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
          style={{
            width: '100%',
            padding: '18px 16px 10px 16px',
            border: '2px solid #e0e0e0',
            borderRadius: 8,
            fontSize: 16,
            outline: 'none',
            background: '#fff',
            transition: 'border 0.2s',
            boxSizing: 'border-box',
          }}
        />
        <label style={getLabelStyle(form.name)}>Tu nombre</label>
      </div>
      {/* Email Field */}
      <div style={{ position: 'relative', marginBottom: 8 }}>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          required
          style={{
            width: '100%',
            padding: '18px 16px 10px 16px',
            border: '2px solid #e0e0e0',
            borderRadius: 8,
            fontSize: 16,
            outline: 'none',
            background: '#fff',
            transition: 'border 0.2s',
            boxSizing: 'border-box',
          }}
        />
        <label style={getLabelStyle(form.email)}>Tu correo</label>
      </div>
      {/* Message Field */}
      <div style={{ position: 'relative', marginBottom: 8 }}>
        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          rows={5}
          required
          style={{
            width: '100%',
            padding: '18px 16px 10px 16px',
            border: '2px solid #e0e0e0',
            borderRadius: 8,
            fontSize: 16,
            outline: 'none',
            background: '#fff',
            transition: 'border 0.2s',
            boxSizing: 'border-box',
            resize: 'vertical',
          }}
        />
        <label style={getLabelStyle(form.message)}>Tu mensaje</label>
      </div>
      <button
        type="submit"
        style={{
          background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          padding: '14px 0',
          fontSize: 17,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(229, 46, 113, 0.10)',
          letterSpacing: 1,
          marginTop: 8,
          transition: 'background 0.2s',
        }}
      >
        Enviar mensaje
      </button>
    </form>
    </div>
  );
} 